import $ from 'jquery';

const backButton = {

    init() {
        this.$button = $('[data-button-back="back"]');

        this.eventHandlers();
    },

    eventHandlers() {
        this.$button.on('click',this.back.bind(this));
    },

    back(e) {
        console.log('test');
        e.preventDefault();
        window.history.back();
    }
}

$(document).ready(()=> {
    backButton.init();
})